import React from "react";
import PropTypes from "prop-types";

import mutationFactory, {
  resetPinCounter as resetPinCounterQ,
} from "model/gql/mutations";

const ResetPinCounter = mutationFactory(resetPinCounterQ);

function CardPinCounterReset(props) {
  const { cardId, children } = props;
  return cardId ? (
    <ResetPinCounter cardId={props.cardId}>
      {({ mutate: resetPinCounter }) => children({ resetPinCounter })}
    </ResetPinCounter>
  ) : (
    children({ resetPinCounter: undefined })
  );
}

CardPinCounterReset.displayName = "CardPinCounterReset";

CardPinCounterReset.propTypes = {
  children: PropTypes.func.isRequired,
  cardId: PropTypes.string.isRequired,
};

CardPinCounterReset.defaultProps = {};

export default CardPinCounterReset;



// WEBPACK FOOTER //
// ./src/data-containers/CardPinCounterReset/CardPinCounterReset.js